import { currencyList, chargesData } from "./StaticData"
import { TableEdit, TableSelect, TableLabel, AgInput, AgSelect, TableComboInput } from "./components/AgComponents"
import { useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import { configStore } from "./state/CommonState"
import {
    quoteDataRec, fclChargesStore, containerStore
} from './state/CommonState'
import { FCLCharge } from "./state/Types"
import ReactDOMServer from 'react-dom/server'
import Utils from "./util/Utils"
import { chargesValidationStore } from "./state/validation-stores"

export default function FCLChargesComp() {
    const imContainerStore = useSnapshot(containerStore)
    const numContainers = imContainerStore.list.length
    const containerNames = imContainerStore.list.map(e => e.containerType)
    const data = chargesData[quoteDataRec.shipmentType]
    let [space, setSpace] = useState('')

    if (fclChargesStore.list.length > 0) {
        let oldchargeskey = []
        Object.entries(fclChargesStore.list[0]).filter(([key, value]) => {
            oldchargeskey.push(key)
        })
        let newchargeskey = []
        oldchargeskey.map(e => {
            if (e.indexOf("'") == -1) {
                newchargeskey.push(e)
            } else {
                containerNames.map(f => {
                    if (e.indexOf(f) > -1) {
                        newchargeskey.push(e)
                    }
                })
            }
        })
        if (oldchargeskey.sort().toString() != newchargeskey.sort().toString()) {
            let newchargelist = []
            fclChargesStore.list.map((e) => {
                var result = Object.fromEntries(newchargeskey.map(col => [col, e[col]]));
                newchargelist.push(result)
            })
            fclChargesStore.list = newchargelist;
        }

    }

    let imChargesStore = useSnapshot(fclChargesStore)
    let a = imChargesStore.newRec
    let b = imChargesStore.editRec

    useEffect(() => {
        console.log('ChargesComp useEffect')
    }, [])
    const deleteRec = (id) => {
        if (id <= imChargesStore.initialLength) return
        const index = fclChargesStore.list.findIndex(e => e.id === id)
        let records = fclChargesStore.list
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        fclChargesStore.list = records
        //console.log('AFTER DELETE=', JSON.stringify(fclChargesStore.cargoList))
    }
    const Th2 = (props) => <th rowSpan="2" {...props} style={{ paddingTop: '1.5rem' }}>{props.children}</th>
    const Ts = ({ i, name, dataList }) => <TableSelect
        record={fclChargesStore.list[i]} name={name} dataList={dataList} isValid={chargesValidationStore.isValidCharge(name, i)} />
    const Te = ({ i, name }) => {
        const e = fclChargesStore.list[i]
        if (name === 'chargeDescription' && i < fclChargesStore.initialLength)
            return <TableLabel record={fclChargesStore.list[i]} name={name} />
        return (
            <TableComboInput record={fclChargesStore.list[i]} name={name} />
        )
    }
    const Tn = ({ i, name }) => {
        const e = fclChargesStore.list[i]
        let disabled = false
        if (e.disabled) {
            for (let i = 0; i < e.disabled.length; i++) {
                if (name.endsWith(e.disabled[i])) {
                    disabled = true
                    break
                }
            }
        }
        if (disabled)
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={fclChargesStore.list[i]} name={name} type='number' isValid={chargesValidationStore.isValidCharge(name, i)} />
        )
    }
    const Tsn = ({ name, dataList }) => <TableSelect
        record={fclChargesStore.newRec} name={name} dataList={dataList} />
    const Ten = ({ name }) => <TableEdit record={fclChargesStore.newRec} name={name} />
    const Tnn = ({ name }) => <TableEdit record={fclChargesStore.newRec} name={name} type='numeric' />
    const ifNotFCL = () => quoteDataRec.shipmentType.indexOf('FCL') < 0

    let grandTotal = {}
    containerStore.list.map(c => {
        grandTotal[c.containerType] = 0.0
        console.log(grandTotal)
    })
    fclChargesStore.list.map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        containerStore.list.map(c => {
            let totalField = c.containerType + 'total'
            grandTotal[c.containerType] += parseFloat(e[totalField]) * erate
        })
    })
    return (
        <>
            <hr />
            <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <th colSpan='2'>
                                <button className="button is-small is-rounded" style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff" }} onClick={() => {

                                    // fclChargesStore.list.map((e, i) => {
                                    //     let erate = configStore.getExchangeRateinr(e)
                                    //     if (!erate || erate === 0) erate = 1.0
                                    //     erate = 1.0 // nullifying the per row conversion.
                                    //     containerStore.list.map(e1 => {
                                    //         let c = e1.containerType
                                    //         let perwmField = c + 'perWM'
                                    //         let pershipmentField = c + 'perShipment'
                                    //         let totalField = c + 'total'
                                    //         if (!e[perwmField]) e[perwmField] = 0
                                    //         if (!e[pershipmentField]) e[pershipmentField] = 0
                                    //         if (!e[totalField]) e[totalField] = 0
                                    //         let perwm = Number(e[perwmField])
                                    //         let pership = Number(e[pershipmentField])
                                    //         let num = Number(e1.numContainers) || 0
                                    //         e[totalField] = Utils.R(
                                    //             (perwm * num + pership) * erate)
                                    //     })
                                    // })
                                    fclChargesStore.calculateChargesTotals();
                                    // setSpace(space === '' ? ' ' : '')
                                }}>Click to Re-Calculate Charges</button>
                            </th>
                            <th colSpan='18'>
                                <h3 className="is-size-5 has-text-centered">Charges{space}</h3>
                            </th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            {containerNames.map(e => (
                                <td className="has-text-centered has-text-weight-bold" colSpan={3}>{e}</td>
                            ))}
                            <th></th>
                        </tr>
                        <tr>
                            <th>ID</th>
                            <th>Charge Description</th>
                            <th>Currency</th>
                            {containerNames.map(e => (
                                <>
                                    <th>Per Container</th>
                                    <th>Per BL</th>
                                    <th style={{ textAlign: "right" }}>Total</th>
                                </>
                            ))}
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            fclChargesStore.list.map((e, i) => {
                                {
                                    return <tr key={e.id}>
                                        <td >{e.id}</td>
                                        <td><Te i={i} name='chargeDescription' /></td>
                                        <td><Ts i={i} name='currency' dataList={currencyList} /></td>
                                        {containerNames.map(e1 => (
                                            <>
                                                <td><Tn i={i} name={e1 + 'perWM'} /></td>
                                                <td><Tn i={i} name={e1 + 'perShipment'} /></td>
                                                <td style={{ textAlign: 'right' }}>
                                                    {
                                                        (e[e1 + 'total'] != 0 && e.currency != '') ?
                                                            Utils.N(e[e1 + 'total'], e.currency) : ''
                                                    }
                                                </td>
                                            </>
                                        ))}
                                        <td>
                                            <div className="field has-addons">

                                                {
                                                    (i >= fclChargesStore.initialLength) ?
                                                        <p className="control">
                                                            <button className="button is-danger is-inverted"
                                                                onClick={() => {
                                                                    deleteRec(e.id)
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon">
                                                                    <i className="fas fa-trash"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    i === fclChargesStore.list.length - 1 && (
                                                        <p className="control">
                                                            <button className="button is-success is-inverted"
                                                                onClick={() => {
                                                                    let obj = fclChargesStore.newRec
                                                                    obj = { ...obj }
                                                                    fclChargesStore.list.push({ ...obj, id: fclChargesStore.list.length + 1 })
                                                                    fclChargesStore.defaultValueCalc() // Need to calculate for validation
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon is-small">
                                                                    <i className="fas fa-plus"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                                    )
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            }
                            )
                        }
                        {/* <tr style={{ border: '2px solid grey' }}>
                            <td ></td>
                            <td><Ten name='chargeDescription'></Ten></td>
                            <td><Tsn name='currency' dataList={currencyList} /></td>
                            {containerNames.map(e => (
                                <>
                                    <td><Tnn name={e + 'perWM'} /></td>
                                    <td><Tnn name={e + 'perShipment'} /></td>
                                    <td><Tnn name={e + 'total'} /></td>
                                </>))}
                            <td>
                                <div className="field has-addons">
                                    <p className="control">
                                        <button className="button is-success is-inverted"
                                            onClick={() => {
                                                let obj = fclChargesStore.newRec
                                                obj = { ...obj }
                                                fclChargesStore.list.push({ ...obj, id: fclChargesStore.list.length + 1 })
                                                setSpace(space === '' ? ' ' : '')
                                            }}>
                                            <span className="icon is-small">
                                                <i className="fas fa-plus"></i>
                                            </span>
                                        </button>
                                    </p>
                                </div>
                            </td>
                        </tr> */}
                        <tr>
                            <td colSpan={3}></td>
                            {
                                containerStore.list.map(c => {
                                    return (
                                        <>
                                            <td></td>
                                            <td></td>
                                            <td style={{ textAlign: 'right' }}>
                                                <strong>
                                                    {Utils.N(grandTotal[c.containerType])}
                                                </strong>
                                            </td>
                                        </>
                                    )
                                })
                            }
                        </tr>
                    </tbody>
                </table>

            </div>
        </>
    )
}
